/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingLogActivityType =
    (typeof BuildingLogActivityType)[keyof typeof BuildingLogActivityType];

export const BuildingLogActivityType = {
    Access: 0,
    Document: 1,
    MaintenanceItem: 2,
    MaintenanceSchedule: 3,
    DocumentPack: 4,
    Ownership: 5,
} as const;
